import http from '../utils/fetch'


export default {
  getTags () {
    return http.get({url: `tags`})
  },
  getOrder (orderCode) {
    return http.get({url: `orders/${orderCode}`})
  },
  getOrders (page, size, orderState,  cb, errorCb) {
    var states = ''
    if (orderState !== 'ALL') {
      states = `&states=${orderState}`
    }
    return http.get({url: `orders?page=${page}&size=${size}${states}`})
  },
  isFinanceServiceBought (companyId) {
    return http.get({url: `orders/finance-bought?companyId=${companyId}`})
  },
  // 提交订单
  addOrder (orderData, cb, errorCb) {
    let carts = orderData.carts
    let cleaned = carts.map(cart => {
      return {
        id: cart.id,
        couponCodeIds: cart.couponCodeIds
      }
    })

    http.post({
      url: 'orders',
      data: {
        ...orderData,
        carts: cleaned,
      }
    })
      .then((res) => {
        cb(res)
      }, (res) => {
        errorCb(res)
      })
  },
  // 修改支付方式
  changePayment (orderCode, payment, comment, openId, cb, errorCb) {
    http.patch({
      url: 'orders',
      data: {
        orderCode: orderCode,
        payment: payment,
        comment: comment,
        openId: openId
      }
    }).then(
      (res) => {
        cb(res)
      },
      (res) => {
        errorCb(res)
      })
  },
  cancelOrder (orderCode, cb, errorCb) {
    http.delete({url: `orders/${orderCode}`}).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  },
  removeOrder (orderCode, cb, errorCb) {
    http.delete({url: `orders?orderCode=${orderCode}`}).then((res) => {
      cb(res)
    }, (res) => {
      errorCb(res)
    })
  },
  /**
   * 未付款订单数量
   */
  countUnpaid(){
    return http.get({url: `orders/unpaid/count`})
  },
  /**
   * 未评价订单数量
   */
  countUnReviewed(){
    return http.get({url: `orders/unreviewed/count`})
    // return http.get({url: `orders/unpaid/count`})
  },
}



// WEBPACK FOOTER //
// ./src/api/order.js